import { useTranslation } from 'react-i18next';

type VisitLocationProps = {
  street: string;
  city: string;
  postalCode: string;
};

/**
 * Component that displays visit location information
 */
export function VisitLocation({ street, city, postalCode }: VisitLocationProps) {
  const { t } = useTranslation();
  const hasLocation = street || city || postalCode;

  if (!hasLocation) {
    return <div className="text-sm">{t('scheduling-no-address')}</div>;
  }

  return (
    <div className="text-sm flex gap-1 flex-wrap">
      {street && <div>{street},</div>}

      {city && <div>{city}</div>}

      {/* {postalCode && <div>{postalCode}</div>} */}
    </div>
  );
}
